'use es6';

import { COMMUNICATION_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import ObjectDefinitionRecord from '../ObjectDefinitionRecord';
const Communication = ObjectDefinitionRecord({
  enableAsAssociatedType: true,
  hasAccess: isUngated => isUngated('CRM:ILSFilters:ActivityFilters'),
  objectTypeId: COMMUNICATION_TYPE_ID,
  referenceObjectType: 'COMMUNICATION_PROPERTIES'
});
export default Communication;